export enum CoreRoutes {
  root = 'core',
  main = '',
  error = 'error',
  forbidden = 'forbidden',
}
